/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TeamSettingAuthorizationResource = {
    AllMembers: 'ALL_MEMBERS',
    OnlyAdministrators: 'ONLY_ADMINISTRATORS'
} as const;
export type TeamSettingAuthorizationResource = typeof TeamSettingAuthorizationResource[keyof typeof TeamSettingAuthorizationResource];


export function instanceOfTeamSettingAuthorizationResource(value: any): boolean {
    for (const key in TeamSettingAuthorizationResource) {
        if (Object.prototype.hasOwnProperty.call(TeamSettingAuthorizationResource, key)) {
            // @ts-ignore
            if (TeamSettingAuthorizationResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamSettingAuthorizationResourceFromJSON(json: any): TeamSettingAuthorizationResource {
    return TeamSettingAuthorizationResourceFromJSONTyped(json, false);
}

export function TeamSettingAuthorizationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamSettingAuthorizationResource {
    return json as TeamSettingAuthorizationResource;
}

export function TeamSettingAuthorizationResourceToJSON(value?: TeamSettingAuthorizationResource | null): any {
    return value as any;
}

